/**
 *
 * @desc 微前端应用系统
 * @author zhuzj
 *
 */
import EventEmitter from 'events';
import {getOrLoadModulePromise, parseURL, debugLog, isEnableCdn} from "./utils/loadResources";
import {asyncUrl2ProjectName, projectName2ContextPath} from "./context";
import luaApi from "./api/luaApi";
import { CookieHelper } from './xscf'

interface IMicroApp{
    onLaunch(options:any):void
    onLaunchError(err:any,options:any):void
}
interface ILoadOptions{
    providerName:string,
    providerHost?:string,
    providerEntry:string,
    onSuccess?:any,
    onError?:any,
    dynamicVersion?:boolean,
    isSmallAppEntryCdn?:boolean,
}

interface ILoadAppOptions extends ILoadOptions{
    appContainerId?:string,
    appProps?:any,
}



/**
 * 远程服务提供方
 */
class ProviderServer {

    providerHost:string;
    providerName:string;
    providerRuntime:any=null;
    providerEntries:any={};
    isSmallAppEntryCdn:boolean=true;

    constructor(name:string,host:string,isSmallAppEntryCdn:boolean = true){
        if(!name){
            throw new Error(`[TNE]缺少必要参数：providerName`);
        }
        this.providerName = name;
        this.providerHost = host;
        this.isSmallAppEntryCdn = isSmallAppEntryCdn;
    }
    // 远程服务是否已加载
    isReady(){
        return !!this.providerRuntime;
    }
    /**
     * 初始化当前服务提供方
     * @param dynamicVersion
     */
    // async init(dynamicVersion){
    //     if(this.providerRuntime){
    //         return this.providerRuntime;
    //     }else{
    //         let hostUrl = this.getHostUrl(dynamicVersion);
    //         await getOrLoadModule(this.providerName, 'default', hostUrl);
    //         const remoteContainer = window[this.providerName];
    //         this.providerRuntime = remoteContainer;
    //         return this.providerRuntime;
    //     }
    // }
    // 当前服务是否初始化准备完毕
    initReady(callback:any,dynamicVersion){
        if(this.providerRuntime){ //服务已存在则无需重复加载
            callback && callback(this.providerRuntime);
        }else{
            this.getHostUrl(dynamicVersion).then((url)=>{
                let hostUrl = url;
                getOrLoadModulePromise(this.providerName, 'default', hostUrl).then((module)=>{
                    this.providerRuntime = module;
                    // console.log("AAA--5--providerRuntime---->",module )
                    callback && callback(this.providerRuntime);
                }).catch((err)=>{
                    this.providerRuntime = null;
                    console.error(err);
                    callback && callback(false,{msg:'请检查资源请求状态或控制台错误日志',err});
                });
            });
        }
    }

    /**
     * 获取当前服务方的入口
     * @param name
     * @return {Promise<*>}
     */
    // async getEntry(name:string):Promise<any> {
    //     if(!this.providerRuntime){
    //         throw new Error(`[TNE]未初始化：provider`);
    //     }
    //     const EntryModuleFactory = await this.providerRuntime.get(name);
    //     const EntryModule = EntryModuleFactory();
    //     return EntryModule;
    // }

    getEntry(name:string,callback) {
        // console.log("AAA--4--getEntry---->"+this.providerName+"!" + name)
        let entryModule = this.providerEntries[name];
        if(entryModule){ //入口已存在则无需重复加载
            callback && callback(entryModule);
        }else{
            this.initReady((provider,err)=>{
                // console.log("AAA--6--getEntry---->" + name,provider)
                if(provider==false){
                    callback && callback(false,err);
                }else{
                    provider.get(name).then((remoteModule)=>{
                        // console.log("AAA--7--getEntry---->" + name,remoteModule)
                        let module = remoteModule();
                        // console.log("AAA--8--getEntry---->" + name,module)
                        this.providerEntries[name] = module;
                        callback && callback(module);
                    }).catch((err)=>{
                        this.providerEntries[name] = null;
                        console.error(err);
                        callback && callback(false,{msg:'请检查控制台错误信息',err});
                    })
                }
            },true);
        }
    }

    /**
     * 获取远程服务者及指定入口
     * @param providerEntry
     * @param dynamicVersion
     */
    getEntryPromise(providerEntry:string,dynamicVersion?:boolean){
        // console.log("AAA--2--providerEntry--get--->" + this.providerName+"/"+providerEntry)
        let that = this;
        return function(){
            return new Promise(function(resolve, reject){
                // console.log("AAA--3--providerEntry--get--->" + that.providerName+"/"+providerEntry)
                if(!providerEntry){
                    reject();
                }
                that.getEntry(providerEntry,(entryModule,err)=>{
                    // console.log("AAA--9--providerEntry--get--->" + that.providerName+"/"+providerEntry)
                    if(entryModule){
                        resolve(entryModule);
                    }else{
                        reject(err);
                    }
                })
            })
        }
    }

    /**
     * 实际访问的url
     * @param dynamicVersion    url是否追加动态版本号
     */
    async getHostUrl(dynamicVersion:boolean=true){
        let hostUrl = `/${this.providerName}.js`;
        if(this.providerHost){
            if(this.providerHost.endsWith('.js')) { //例如："https://bip-daily.yyuap.com/iuap-xxx/app.js" 或 "/iuap-xxx/app.js"
                hostUrl = this.providerHost;
            }else if(this.providerHost.endsWith('/')) { //例如："https://bip-daily.yyuap.com/iuap-xxx/" 或 "/iuap-xxx/"
                hostUrl = this.providerHost+`${this.providerName}.js`;
            }else{// 例如："https://bip-daily.yyuap.com/iuap-xxx" 或 "/iuap-xxx"
                hostUrl = this.providerHost+`/${this.providerName}.js`;
            }
        }
        if(dynamicVersion){
            hostUrl=hostUrl+'?t='+(new Date().getTime());
        }
        let cdnUrl = '';
        if(this.isSmallAppEntryCdn === false){
            return hostUrl
        }
        
        if(!isEnableCdn()){
            let isNoGpaas = true;
            // 判断当前是否是技术中台，ymscloud不走cdn入口
            try {
                if(hostUrl.indexOf('iuap-yms-manage/ucf-wh') > -1){
                    isNoGpaas = false;
                }
            } catch (error) {
                
            }
            // 专属化模式下，走CDN地址访问，
            if(!hostUrl.startsWith('http') && isNoGpaas){
                let pre = ""
                if(!hostUrl.startsWith('/')){
                    pre = "/"
                }
                hostUrl = (window.cdn_privateHost || "") + pre + hostUrl
            }
        }
        try {
            cdnUrl = await this.getCdnEntryHostUrl()
        } catch (error) {
            console.log('获取CDN入口文件失败，降级采用相对域名地址访问',error)
        }
        return cdnUrl || hostUrl;
    }

    // 根据zone-fe获取版本号，支持多版本部署访问
    getZoneFeCookieVersion(appCode){
        let cookieValue = CookieHelper.read('zone-fe');
        if(!cookieValue){
            return ''
        }else{
            const result: any = {};
            cookieValue = cookieValue.split(",");
            for (const pair of cookieValue) {
                const [project, version] = pair.split(":");
                if (project && version) {
                    result[project] = version;
                }
            }
            return result[appCode]
        }
    }

    //获取入口文件cdn地址
    async getCdnEntryHostUrl(){
        function isURL(url) {
            return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
        }
        let contextCdn: any = {};
        let appCode = '';
        let projects = {};
        let providerHost = this.providerHost;
        try {
            // 判断providerHost是否带着域名（带域名一般为社会化应用）
            let isUrl = isURL(providerHost);
            let providerHostUrlInfo:any = {};
            // 获取社会化应用域名
            let hostDomain = '';
            if(isUrl){
                providerHostUrlInfo = parseURL(providerHost);
                hostDomain = providerHostUrlInfo.hostDomain;
            }
            const baseURL = window.TNS_BASE_HOST || window.location.origin;
            // 判断当前域名与versionsdk请求域名是否一致，一致不需要再发起请求
            if(hostDomain && hostDomain !== baseURL){
                // 社会化应用需要请求社会化域名的cdn和版本文件
                contextCdn = await luaApi.asyncFetchContextByDomain(hostDomain);
                projects = await luaApi.asyncFetchAllProjectsByDomain(hostDomain);
                appCode = await asyncUrl2ProjectName(providerHost, projects);
            }else{
                if(!providerHost.startsWith('/')){
                    providerHost = '/' + providerHost
                }
                contextCdn = await luaApi.asyncFetchContext();
                appCode = await asyncUrl2ProjectName(providerHost);
                projects = await luaApi.asyncFetchAllProjects();
            }
        } catch (error) {
            console.log('获取cdn域名失败',error)
        }
        let cdnHost = '';
        if(contextCdn && contextCdn.cdnHost) cdnHost = contextCdn.cdnHost;
        // /iuap-yms-manage-fe => /iuap-yms-manage/ucf-wh/
        let contextPath = projectName2ContextPath(appCode);
        // /iuap-yms-manage/ucf-wh(去除最后一个/)
        contextPath = contextPath.endsWith('/') ? contextPath.substring(0,contextPath.length-1) : contextPath;
        let afterPath = providerHost.split(contextPath)[1];
        let endPath = `${this.providerName}.js`;
        // 兼容以.js结尾的入口
        if (afterPath.endsWith(".js")) {
            endPath = ''
        } else {
            if (afterPath && !afterPath?.endsWith("/")) {
                afterPath += "/";
            }
        }
        if (afterPath && afterPath.startsWith("/")) {
            // /iuap-yms-manage/ucf-wh/app => /app
            afterPath = afterPath.substring(1);
        }
        let version = projects[appCode]?.version;
        try {
            version = this.getZoneFeCookieVersion(appCode) || version;
        } catch (error) {
            console.log('获取cookie【zone-fe】版本失败',error)
        }
        let cdnURL = ""
        if(cdnHost && version){
            cdnURL = `${cdnHost}/static/ucf/${appCode}/${version}/${afterPath}${endPath}`;
        }
        return cdnURL;
    }
}

/**
 * 事件代理对象
 */
class EventProxy {
    private id:string;
    private eventEmit = new EventEmitter();//当前服务方的事件中心
    constructor(id){
        this.id = id;
        this.eventEmit.setMaxListeners(9999);
    }
    // 注册一个事件监听
    on(eventName:string,eventFunc:any){
        this.eventEmit.on(eventName,eventFunc);
        return this;
    }
    // 注册一次性的事件监听
    once(eventName:string,eventFunc:any){
        this.eventEmit.once(eventName,eventFunc);
        return this;
    }
    // 取消一个事件监听
    off(eventName:string,eventFunc:any){
        this.eventEmit.off(eventName,eventFunc);
        return this;
    }
    // 触发一个事件
    emit(eventName:string,...args: Array<any>){
        this.eventEmit.emit(eventName,...args);
        return this;
    }
    // 清除全部注册事件
    clear(){
        this.eventEmit.eventNames().forEach((eventName)=>{
            this.eventEmit.removeAllListeners(eventName);
        });
        return this;
    }
}


/**
 * 对外运行时提供的api服务
 */
class MicroSystemRuntime{

    private providers : Record<string,ProviderServer> = {}; //管理多个服务提供方

    private loadQueue:{providerName:string,providerEntry:string,promiseFunc:any,onSuccess:any,onError:any}[] = []; // 执行加载中的队列

    private runtimeEntrys = {}; //管理多个运行时入口

    private providerEvents = {}; //管理全部服务方事件中心

    //微应用服务提供者是否已准备就绪
    providerIsReady(providerName:string){
        if (!this.providers[providerName]) return false;
        return this.providers[providerName].isReady();
    }

    /**
     * 设置微应用服务提供者的配置
     */
    setProviderConfig(providerName:string,configs:Record<any,any>){
        if(!this.providers[providerName]){
            this.providers[providerName] = new ProviderServer(providerName,configs.providerHost);
        }else{
            this.providers[providerName].providerHost = configs.providerHost;
        }
    }

    /**
     * 获取远程服务者及指定入口
     * @param providerEntry
     * @param providerName
     * @param providerHost
     * @param dynamicVersion
     */
    getProviderEntry(providerName:string,providerEntry:string,providerHost:string='',dynamicVersion?:boolean,isSmallAppEntryCdn?:boolean){
        if(!this.providers[providerName]){
            this.providers[providerName] = new ProviderServer(providerName,providerHost,isSmallAppEntryCdn);
        }
        const provider = this.providers[providerName];
        const entryPromise = provider.getEntryPromise(providerEntry,dynamicVersion);
        return entryPromise;
    }

    /**
     * 获取服务者的事件中心代理
     * @param providerName
     */
    getProviderEventProxy(providerName:string){
        if(!this.providerEvents[providerName]){
            this.providerEvents[providerName] = new EventProxy(providerName);
        }
        return this.providerEvents[providerName];
    }

    // // 运行微前端应用
    // launch(options:ILoadAppOptions){
    //     //跟react\vue等框架解耦合
    //     let {providerName,providerHost,appContainerId,providerEntry,appProps,onSuccess,onError,dynamicVersion} = options;
    //     if(appContainerId){//可选参数，如果参数存在值，则进行校验，确保元素已创建。
    //         const appContainer = document.getElementById(appContainerId);
    //         if(!appContainer){
    //             console.error(`[TNE]document.getElementById('${appContainerId}')找不到元素`);
    //             return;
    //         }
    //     }
    //     const promiseFunc = this.getProviderEntry(providerName,providerEntry,providerHost,dynamicVersion);
    //     this._pushQueue(providerName,providerEntry,promiseFunc,(defaultModule)=>{
    //         let microApp:IMicroApp = {onLaunch:()=>{},onLaunchError:()=>{}};//微应用的基础模型
    //         let vaild = false; //是否为有效的模型
    //         try{
    //             if(typeof defaultModule == 'function'){
    //                 microApp = defaultModule();
    //                 if(typeof microApp.onLaunch == 'function'){
    //                     vaild = true;
    //                     console.log(`[TNE]微前端应用：${providerName} 入口:${providerEntry} onLaunch`);
    //                     microApp.onLaunch({appContainerId,providerName,providerEntry,appProps});
    //                 }
    //             }
    //             onSuccess && onSuccess();
    //         }catch (launchErr) {
    //             console.warn(`[TNE]微前端应用执行异常`,launchErr);
    //             typeof microApp.onLaunchError == 'function' && microApp.onLaunchError(launchErr,{appContainerId,providerName,providerEntry,appProps});
    //             onError && onError();
    //         }
    //         if(!vaild){ //不是有效的定义格式则给出提示
    //             console.error(`[TNE]微前端应用编码：${providerName} 入口:${providerEntry}，未定义方法:
    //             export default function (microSystem){
    //                 return {
    //                     onLaunch:(options)=>{},
    //                     onLaunchError:(options)=>{}
    //                 }
    //             }
    //             `);
    //             onError && onError();
    //         }
    //     },(e)=>{
    //         // let errMsg = e+'';
    //         // if(errMsg.indexOf('does not exist in container')){
    //         //     errMsg = `[TNE]微前端应用不存在，编码：${providerName} 入口:${providerEntry}`;
    //         // }else if(errMsg.indexOf('load remote is error')){
    //         //     errMsg = `[TNE]微前端应用资源加载异常，URL:${providerHostUrl}`;
    //         // }
    //         console.error('[TNE]微前端应用运行异常:', e);
    //         typeof onError == 'function' && onError({appContainerId,providerName,providerEntry,appProps,error:e});
    //     });
    //     this._startQueue();
    // }

    // /**
    //  * 获取异步微函数
    //  */
    // loadFunction(options:ILoadOptions){
    //     let {providerName,providerHost,providerEntry,onSuccess,onError,dynamicVersion} = options;
    //     let promiseFunc = this.getProviderEntry(providerName,providerEntry,providerHost,dynamicVersion);
    //     this._pushQueue(providerName,providerEntry,promiseFunc,(module)=>{
    //         onSuccess && onSuccess(module()) //注意此处执行module()
    //     },onError);
    //     this._startQueue();
    // }

    /**
     * 获取异步微组件
     */
    // async loadComponent(options) {
    //     let {providerName,providerHost,providerEntry,onError,dynamicVersion} = options;
    //     const module = await this.getProviderEntry(providerEntry,providerName,providerHost,dynamicVersion);
    //     const entryComp = module && module.__esModule ? module.default:module;
    //     return entryComp;
    // }

    // 从url中解析加载的配置
    parseLoadConfig(url){
        // https://local.yyuap.com:3002/#/myAppProvider!bootstrap/tinperComponents?aaa=b
        // /abc?serviceCode=c1b6bb1b-82be-4fec-8e19-6410c33db589&refimestamp=1661326261614#/eventCenter!eventCentryEntry/?providerHost=/iuap-apcom-event/ucf-wh/dist-react/js/&myType=1
        // /privider!name/listqq?serviceCode=d025c161-2ca5-4edd-8b35-79ed458715fb&refimestamp=1661391768329
        if(!url) return {};
        let hash = '';
        if(url.indexOf('#')>-1){ //存在hash标识
            hash = url.split('#')[1];
        }else{
            hash = url;
        }
        let hashSp = hash.split('?');
        let path = hashSp[0] || "";
        let search = hashSp[1];
        let params:any = (function(){
            let ret = {};
            if(!search)return ret;
            let seg = search.split('&'),
                len = seg.length, i = 0, s;
            for (;i<len;i++) {
                if (!seg[i]) { continue; }
                s = seg[i].split('=');
                ret[s[0]] = decodeURIComponent(s[1]);
            }
            return ret;
        })();
        let loadConfig:any = {};
        let routeMatch= path.match(/^\/[a-zA-Z0-9_]+![a-zA-Z0-9_]+\//);// 匹配 前后带"/"，中间带"!"的字符段，例如："/myAppProvider!bootstrop/"
        // 默认按路径规范取值
        if(routeMatch) {
            let routeName = routeMatch[0]; //==》"/myAppProvider!bootstrop/"
            let routeInfo = routeName.replace(/\//g, "").split("!");//剔除全部"/"，按"!"拆分。
            loadConfig.providerName = routeInfo[0];
            loadConfig.providerEntry = routeInfo[1];
            loadConfig.routePath = path.replace('/'+loadConfig.providerName+"!"+loadConfig.providerEntry,'');  // 输入 "/AI_console_index!bootstrap/model" ==> 输出 "/model"
        }
        // 参数规范的优先级高于路由规范
        if(Object.keys(params).length){
            loadConfig.providerHost=params['providerHost']||loadConfig.providerHost;
            loadConfig.providerName=params['providerName']||loadConfig.providerName;
            loadConfig.providerEntry=params['providerEntry']||loadConfig.providerEntry;
            loadConfig.providerMode=params['providerMode']||loadConfig.providerMode;
            loadConfig.routePath=params['routePath']||loadConfig.routePath;
            loadConfig.routeParam=params;
            ['providerHost','providerName','providerEntry','providerMode','routePath'].forEach((key)=>delete loadConfig.routeParam[key]);//排除内部属性
        }
        return loadConfig;
    }

    loadComponent(options:ILoadOptions) {
        let {providerName,providerHost,providerEntry,onSuccess,onError,dynamicVersion,isSmallAppEntryCdn} = options;
        // console.log("AAA--1---loadComponent--->"+providerName+"!"+providerEntry);
        //已存在则无需进行队列直接返回
        if(this.runtimeEntrys[providerName+"!"+providerEntry]){
            onSuccess && onSuccess(this.runtimeEntrys[providerName+"!"+providerEntry])
        }else{//需要异步加载则进入到队列执行
            const promiseFunc = this.getProviderEntry(providerName,providerEntry,providerHost,dynamicVersion, isSmallAppEntryCdn);
            // promise().then((module)=>{
            //     console.log("AAA--9--loadComponent---->" + providerName)
            //     const entryComp = module && module.__esModule ? module.default:module;
            //     onSuccess && onSuccess(entryComp)
            // }).catch((err)=>{
            //     onError && onError(err);
            // });
            // console.log("AAA---2---stack--->+",this.stack.length);
            this._pushQueue(providerName,providerEntry,promiseFunc,onSuccess,onError);
            this._startQueue();
        }
    }

    // 并发执行时，Promise存在冲突、重置等问题，通过队列解决此问题。
    _startQueue(){
        const {loadQueue} = this;
        let that = this;
        if(loadQueue.length<=0)return;
        let start = loadQueue[0];

        start.promiseFunc().then(function(module){
            let defaultModule = module && module.__esModule ? module.default:module;
            console.log("[TNE]队列:排出("+loadQueue.length+")-->"+start.providerName+"!"+start.providerEntry);
            loadQueue.shift();
            that.runtimeEntrys[start.providerName+"!"+start.providerEntry] = defaultModule;//队列结果进行缓存
            start.onSuccess && start.onSuccess(defaultModule);
            that._startQueue();
        }).catch(function(err){
            console.log("[TNE]队列:排出("+loadQueue.length+")-->"+start.providerName+"!"+start.providerEntry,err);
            loadQueue.shift();
            that.runtimeEntrys[start.providerName+"!"+start.providerEntry] = null;// 异常后队列进行清理
            start.onError && start.onError(err);
            that._startQueue();
        });

    }
    // 将Promise放入队列
    _pushQueue(providerName,providerEntry,promiseFunc,onSuccess,onError){
        this.loadQueue.push({providerName,providerEntry,promiseFunc,onSuccess,onError});
        console.log("[TNE]队列:排入("+this.loadQueue.length+")-->"+providerName+"!"+providerEntry);
    }

}


export default MicroSystemRuntime;
